<template>
  <div class="flex shrink-0 gap-2 overflow-x-auto bg-slate-50 p-4">
    <slot />
  </div>
</template>
